<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="bg-sidebar text-white print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.futuristic"
  [opened]="!isScreenSmall"
>
  <ng-container fuseVerticalNavigationHeader>
    <div class="flex h-40 items-center justify-center p-6 pb-0">
      <img class="w-36" [src]="logoUrl" />
    </div>
  </ng-container>

  <ng-container fuseVerticalNavigationFooter>
    <app-user></app-user>
  </ng-container>
</fuse-vertical-navigation>

<div class="flex w-full min-w-0 flex-auto flex-col">
  <div
    class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
  >
    <div class="flex items-center space-x-0.5 sm:space-x-2">
      <button
        mat-icon-button
        (click)="toggleNavigation('mainNavigation')"
      >
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
      </button>

      <button
        mat-flat-button
        (click)="toggleTheme()"
      >
        <mat-icon [svgIcon]="isDarkTheme ? 'heroicons_outline:sun' : 'heroicons_outline:moon' "></mat-icon>
      </button>
    </div>

    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      <app-merchant-selector></app-merchant-selector>

      <languages></languages>

      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
    </div>
  </div>

  <div class="flex flex-auto flex-col bg-color-main">
    <router-outlet></router-outlet>
  </div>

  <div
    class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent md:px-6 print:hidden"
  >
    <span class="text-secondary font-medium">
      S-PAY &copy; {{ currentYear }}
    </span>
  </div>
</div>
